class SlideAnimation {
  constructor(option = {}) {
    // this.init(option)
  }

  init(option = {}) {
    this.createWrapper()
    this.animationType = option.animationType || 'bar'
    this.el = document.querySelector('.animation-hook') // option.el
    if (!this.el) {
      return
    }
    this.slideList = option.slideList || []
    this.activeIndex = 0
    this.container_width = parseInt(getComputedStyle(this.el).width); // 计算外层容器的总宽度
    this.container_height = parseInt(getComputedStyle(this.el).height); // 计算外层容器的总高度
    // this.slice_num = option.slice_num || 10 // bar 用10适合 //   barHorizontal 3
    this.slice_num = option.slice_num || 10


    this.transition_time = 0.5
    this.transition_delay = 0.1
    if (this.animationType === 'bar') {
      // 这是bar比较适合的速度
      this.transition_time = 0.5
      this.transition_delay = 0.1
      this.slice_num = 10
    }
    if (this.animationType === 'barHorizontal') {
      // barHorizontal
      this.transition_time = 1
      this.transition_delay = 0
      this.slice_num = 3
    }
    if (this.animationType === 'barCube') {
      // barCube
      this.transition_time = 1
      this.transition_delay = 0.1
      this.slice_num = 10
    }
    if (this.animationType === 'barUpDown') {
      this.transition_time = 0.4
      this.transition_delay = 0.1
      this.slice_num = 10
    }

    this.rate = 1 / this.slice_num; // 计算每个切块占比
    this.unit_width = this.container_width * this.rate; // 每一个切块的宽度

    this.clear()

  }

  entrance(toIndex, fromIndex) {

    $(this.el).css({
      'z-index': '1',
      opacity: 1,
    })


    this.render(toIndex, fromIndex)
    this.animation()

    setTimeout(() => {
      this.handleSwiperPageBeforeAnimation(toIndex, fromIndex)
      setTimeout(() => {
        this.handleSwiperPageAfterAnimation(toIndex, fromIndex)
      }, 900)
    })


  }

  render(toIndex, fromIndex) {
    const renderFun = this.animationType + 'Render';
    this[renderFun](toIndex, fromIndex);
  }

  animation() {
    const animationFun = this.animationType + 'Animation';
    this[animationFun]();
    setTimeout(() => {
      $(this.el).css({
        'z-index': 0,
        opacity: 0,
      })
    }, 2000)
  }

  barRender(toIndex) {
    this.clearHtml();
    let src = this.slideList[toIndex].data.full_screen_banner.src
    this.el.style.overflow = "hidden";
    let html = '';
    Array.from(Array(this.slice_num)).forEach((v, i) => {
      html += `
       <div style="position:absolute;width:${
        this.unit_width
      }px;height:100%;left:${
        i * this.unit_width
      }px;overflow:hidden;top:-100%;transition:top linear ${
        this.transition_time
      }s ${i * this.transition_delay}s;">
            <img src="${src}" style="position:absolute;height:100%;width:${
        100 * this.slice_num
      }%;left:${-i * this.unit_width}px"/>
       </div>
    `;
    });

    const wrapper = document.createElement('DIV');
    wrapper.setAttribute('class', 'hook');
    wrapper.setAttribute('style', 'position:absolute;width:100%;height:100%;');
    wrapper.innerHTML = html;
    this.el.appendChild(wrapper);
  }

  barHorizontalRender(toIndex) {
    this.clearHtml();
    let src = this.slideList[toIndex].data.full_screen_banner.src

    this.el.style.overflow = "hidden";

    let html = '';
    /// this.transition_time

    Array.from(Array(this.slice_num)).forEach((v, i) => {
      html += `
       <div class="bar-wrapper" style="position:absolute;width:${this.unit_width}px;height:100%;left:${
        i * this.unit_width
      }px;overflow:hidden;top:0;transition:width ease-out ${
        this.transition_time
      }s ${this.transition_delay}s;">
         <div style="position:absolute;width:${this.unit_width}px;height:100%;overflow: hidden;left:-100%;transition:left ease-out ${
        (i * 0.2 + 0.4)
      }s ${this.transition_delay}s;">
              <img src="${src}" style="position:absolute;height:100%;width:${
        100 * this.slice_num
      }%;left:${-i * this.unit_width}px"/>
         </div>
        </div>
    `;
    });

    const wrapper = document.createElement('DIV');
    wrapper.setAttribute('class', 'hook');
    wrapper.setAttribute('style', 'position:absolute;width:100%;height:100%;');
    wrapper.innerHTML = html;
    this.el.appendChild(wrapper);
  }

  barCubeRender(toIndex, fromIndex) {
    this.clearHtml();
    let current_img = this.slideList[fromIndex].data.full_screen_banner.src
    let next_img = this.slideList[toIndex].data.full_screen_banner.src

    let html = '';

    // const current_img = 'https://img01.71360.com/file/read/www/M00/1A/E3/wKgDYl8s91qAO2FoAAnUImfRqRc541.jpg'//$('img', this.eles[this.index])[0].getAttribute('src'); //当前图片路径
    //
    // const next_img = 'https://preapiconsole.71360.com/file/read/www/M00/0F/55/wKj0f2FNcfSAXlspAA2hGUHyKMw794.jpg'  //$('img', this.eles[this.new_index])[0].getAttribute('src'); //下一张图片路径

    Array.from(Array(this.slice_num)).forEach((v, i) => {
      html += `
      <div class="container" style="left:${i * this.unit_width}px;width:${
        this.unit_width
      }px">
       <div class="wrapper" style="width:${
        this.unit_width
      }px;transition:transform linear ${this.transition_time}s">
            <div class="left"></div>
            <div class="right" style="transform: translateX(${
        this.unit_width
      }px) rotateY(90deg);width:${this.container_height}px"></div>
                    <div class="front"><img src="${current_img}" style="position:absolute;height:100%;width:${
        100 * this.slice_num
      }%;left:${-i * this.unit_width}px"/></div>
                    <div class="up" style="transform: rotateX(90deg) translateZ(${
        this.container_height
      }px);"><img src="${next_img}" style="position:absolute;height:100%;width:${
        100 * this.slice_num
      }%;left:${-i * this.unit_width}px"/></div>
       </div>
      </div>
    `;
    });

    const wrapper = document.createElement('DIV');

    wrapper.setAttribute('class', 'hook');

    wrapper.setAttribute('style', 'position:absolute;width:100%;height:100%;');

    wrapper.innerHTML = html;

    this.el.appendChild(wrapper);
  }

  async barAnimation() {
    const eles = query('.hook div', this.el);
    await Delay(0);
    eles.forEach((el) => {
      el.style.top = 0; //启动动画
      el.addEventListener('transitionend', this.completeAnimate.bind(this));
    });
  }

  async barHorizontalAnimation() {
    const eles = query('.hook .bar-wrapper div', this.el);
    await Delay(0);
    eles.forEach((el) => {
      // el.style.width = this.unit_width + 'px'; //启动动画
      el.style.left = '0px'; //启动动画
      el.addEventListener('transitionend', this.completeAnimate.bind(this));
    });
  }

  async barCubeAnimation() {
    const eles = query('.hook .wrapper', this.el);
    // this.eles[this.index].style.display = 'none';
    let el;
    await Delay(0);
    while ((el = eles.shift())) {
      el.style.transform = `translateZ(${
        -this.container_height / 2
      }px) rotateX(-90deg) translateZ(${this.container_height / 2}px)`;
      this.bindleftAnimate(el);
      el.addEventListener('transitionend', this.completeAnimate.bind(this));
      await Delay(this.transition_delay * 1000);
    }
  }

  barUpDownRender(toIndex, fromIndex) {
    this.clearHtml();
    let src = this.slideList[toIndex].data.full_screen_banner.src
    this.el.style.overflow = "hidden";
    let html = '';

    Array.from(Array(this.slice_num)).forEach((v, i) => {
      let top = i % 2 === 0 ? '-100%' : '100%'
      html += `
       <div style="position:absolute;width:${
        this.unit_width
      }px;height:100%;left:${
        i * this.unit_width
      }px;overflow:hidden;top:${top};transition:top linear ${
        this.transition_time
      }s ${i * this.transition_delay}s;">
            <img src="${src}" style="position:absolute;height:100%;width:${
        100 * this.slice_num
      }%;left:${-i * this.unit_width}px"/>
       </div>
    `;
    });

    const wrapper = document.createElement('DIV');
    wrapper.setAttribute('class', 'hook');
    wrapper.setAttribute('style', 'position:absolute;width:100%;height:100%;');
    wrapper.innerHTML = html;
    this.el.appendChild(wrapper);
  }

  async barUpDownAnimation() {
    const eles = query('.hook div', this.el);
    await Delay(0);
    eles.forEach((el) => {
      el.style.top = 0; //启动动画
      el.addEventListener('transitionend', this.completeAnimate.bind(this));
    });
  }

  clearHtml() {
    const elements = query('.hook', this.el);
    elements.length > 0 &&
    elements.forEach((element) => {
      this.el.removeChild(element);
    });
  }

  clear() {
    this.el.innerHTML = ''
  }

  completeAnimate() {

  }

  bindleftAnimate(el) {
    const distance = this.unit_width * 2.5;

    const time = this.transition_time * 1000;

    const a = (-4 * distance) / (3 * time * time);

    const b = (4 * distance) / (time * 3);

    let t = 0;

    function updateDom() {
      //模拟抛物线方程 y = ax^2 + bx
      el.style.left = -1 * (a * t * t + b * t) + "px";
      setTimeout(() => {
        t += 20;
        if (t <= time) {
          updateDom();
        }
      }, 20);
    }

    updateDom();

  };

  handleSwiperPageBeforeAnimation(toIndex, fromIndex) {
    $('.swiper-container .swiper-slide').eq(toIndex).css({
      opacity: 0,
      // 'transition-duration': '10ms'
    })
    $('.swiper-container .swiper-slide').eq(fromIndex).css({
      opacity: 1,
      // 'transition-duration': '10ms'
    })
  }

  handleSwiperPageAfterAnimation(toIndex, fromIndex) {
    $('.swiper-container .swiper-slide').eq(toIndex).css({
      opacity: 1,
      // 'transition-duration': '10ms'
    })
    $('.swiper-container .swiper-slide').eq(fromIndex).css({
      opacity: 0,
      // 'transition-duration': '10ms'
    })
  }

  hideHook() {
    $(this.el).css({
      display: 'none'
    })
  }

  createWrapper() {
    if (!$(' .full_screen_banner').find('.animation-hook').length) {
      $('.full_screen_banner').append('<div class="animation-hook"></div>')
    }
  }

}

function query(condition, context) {
  if (context == null) {
    context = document;
  }
  return Array.prototype.slice.call(context.querySelectorAll(condition), 0);
}

function Delay(time) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(null);
    }, time);
  });
}

export default SlideAnimation



// WEBPACK FOOTER //
// ./src/base/slideAnimation.js